export const ATTACHMENT_CATEGORY_OVERVIEW = 'overview';
export const ATTACHMENT_CATEGORY_ADC = 'adc';
